<template>
    <el-header :class="headerClass" ref="header">
        <div class="header-content">
            <div class="header-logo" @click="handleHeaderClick"></div>
            <el-menu :default-active="activeIndex" class="el-menu-head" mode="horizontal" @select="handleSelect">
<!--                <el-menu-item index="/Notice">-->
<!--                    <router-link to="/Notice">首页</router-link>-->
<!--                </el-menu-item>-->


                <el-menu-item index="/home">
                    <router-link to="/home">招聘职位</router-link>
                </el-menu-item>
                <el-menu-item index="/profile">
                    <router-link to="/profile">招聘要求</router-link>
                </el-menu-item>


<!--                <el-menu-item index="/recruit">-->
<!--                    <router-link to="/recruit">招聘职位</router-link>-->
<!--                </el-menu-item>-->


                <el-menu-item index="/resume">
                    <router-link to="/resume">提交简历</router-link>
                </el-menu-item>
<!--                <el-menu-item index="/preaching">-->
<!--                    <router-link to="/preaching">校园宣讲行程</router-link>-->
<!--                </el-menu-item>-->


                <div class="about">
                    <a :href="bgiURL" target="_Blank">了解北勘</a>
                </div>
            </el-menu>

        </div>
    </el-header>
</template>

<script>
    export default {
        name: 'Header',
        data() {
            return {
                activeIndex: this.$route.path,
                headerClass: 'header',
                bgiURL:"http://bgi.com.cn?number="+Math.random()

            }
        },
        mounted: function () {
            this.$nextTick(function () {
                window.addEventListener('scroll', this.onScroll)
            });
            this.$router.beforeEach((to, form, next) => {
                if (to.path === '/home') {
                    this.headerClass = 'header header-ex';
                } else {
                    this.headerClass = 'header';
                }
                next();
            });
            if (this.$route.path === '/home') {
                this.headerClass = 'header header-ex';
            }

        },
        methods: {
            handleSelect() {

            },
            handleHeaderClick() {
                this.$router.push('/home')
            },

            onScroll() {
                if (this.$route.fullPath === '/home') {
                    let scrolled = document.documentElement.scrollTop || document.body.scrollTop;
                    if (scrolled > 120) {
                        this.headerClass = 'header';
                    } else if (scrolled < 120) {
                        this.headerClass = 'header header-ex';
                    }
                }
            },
        },
        watch: {
            '$route'(to) {
                this.activeIndex = to.path;
            }
        }
    }
</script>

<style scoped lang="less">
    .header {
        z-index: 20;
        position: fixed;
        top: 0;
        width: 100%;
        min-width: 1280px;
        box-shadow: 0 0 1px #CCC;
        border-bottom: 1px solid #CCC;
        background: #FFF;
        font-weight: 600;
        .el-menu--horizontal {
            border-bottom: none;
            font-size: 18px;
        }
        .header-content {
            display: flex;
            justify-content: space-between;
            margin: 0 auto;
            /*width: 1400px;*/
            padding: 0 50px;
            position: relative;
            .header-logo {
                position: relative;
                top: 0;
                left: 0;
                float: left;
                display: inline-block;
                height: 60px;
                width: 180px;
                background: url("../assets/logo3.png") no-repeat left center;
                transition-property: background;
                transition-duration: .3s;
                &:hover {
                    cursor: pointer;
                }
            }
            .el-menu-head {
                position: relative;
                float: right;
                display: inline-block;
                background: transparent;

                .el-menu-item {
                    margin-right: 10px;
                    padding: 0;
                    height: 60px;
                    line-height: 60px;
                    font-size: 18px;
                    &:hover {
                        background: #EEE;
                    }
                    a {
                        padding: 30px 20px;
                        text-decoration: none;
                    }
                    &.is-active {
                        border-bottom: 3px solid #006eab;
                    }
                }

                .about {
                    display: inline-block;
                    padding: 0;
                    height: 60px;
                    line-height: 60px;
                    &:hover {
                        background: #EEE;
                    }
                    a {
                        color: #909d99;
                        transition-property: color;
                        transition-duration: .3s;
                        padding: 30px 20px;
                        text-decoration: none;
                        &:hover {
                            color: #303133;
                        }
                    }

                }
            }
        }
    }

    .header-ex {
        box-shadow: none;
        border-bottom: none;
        background: transparent;
        .header-content {
            .header-logo {
                background: url("../assets/logo4.png") no-repeat left center;
                transition-property: background;
                transition-duration: .3s;
            }
            .el-menu-head {
                .el-menu-item {
                    color: #FFF;

                    &:not(.is-disabled):hover {
                        background-color: transparent;
                        color: #FFF;
                        text-shadow: 0 0 2px #fff;
                    }
                    &.is-active {
                        color: #FFF;
                    }
                }
                .about {
                    &:hover {
                        background: transparent;
                    }
                    a {
                        color: #FFF;
                        transition-property: color;
                        transition-duration: .3s;
                        &:hover {
                            color: #FFF;
                            text-shadow: 0 0 2px #fff;
                        }
                    }
                }
            }
        }
    }

</style>
